angular.module('dpw.services')

    // blogInfo service hosts data that shared between controllers.
    .factory('blogInfo', function () {
        var host = '';
        return {
            host: function (value) {
                value && (host = value);
                return host;
            }
        };
    });